export default class Error {
  constructor() {
    this.setScene();
    this.setEvent();
  }

  update() {
    this.setScene();
  }

  setScene() {
    $('#view-error .err-wrap').hide();
    $(`#view-error .err-wrap.${TMON.oApp.htViews.scene}`).show();
  }

  setEvent() {
    $('.err-wrap [data-role=login]').on('click', this.login);
    $('.err-wrap [data-role=goHome]').on('click', this.goHome);
  }

  login = e => {
    TMON.oApp.oUtil.login(window.location.href, '', true);
    e.preventDefault();
  };

  goHome = e => {
    if (TMON.view_mode === 'app') {
      e.preventDefault();
      TMON.app.callApp('webview', 'goHome');
    }
  };
}
